import React from "react";
import { ASSETS } from "@/lib/content";

// Single gold crescent-moon + ribbon motif, used everywhere a moon accent appears.
export const MoonMark = ({ className = "" }) => (
  <img
    src={ASSETS.moon}
    alt=""
    aria-hidden="true"
    draggable="false"
    className={`object-contain inline-block select-none ${className}`}
  />
);

export default MoonMark;
